"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconChime', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M9.60255 0.800812L9.58449 4.30401L12.7492 2.71779L12.7501 2.7168L14.1189 4.0856L14.1177 4.08623L11.6277 6.55043L14.9876 7.66615V9.60209L11.48 9.58405L13.0662 12.747L11.6973 14.1161L9.23944 11.6325L8.12075 15.0007L6.18567 15.0003L6.20373 11.4966L3.0386 13.083L3.03762 13.084L1.6691 11.7151L4.15951 9.25045L0.800049 8.13485L0.800171 6.19855L4.30771 6.21663L2.72168 3.05349L4.09058 1.68469L6.54814 4.16799L7.66376 0.808363L7.66406 0.804688L7.66646 0.800232L9.60255 0.800812ZM9.64531 9.32727L9.42371 9.54887L8.0803 10.1631H7.80715L6.45329 9.65884L6.23682 9.44159L5.63765 8.13302V7.82125L6.13646 6.47967L6.36418 6.25189L7.70691 5.63783L7.98096 5.63783L9.33457 6.14204L9.55141 6.35897L10.15 7.66793L10.1502 7.97978L9.65153 9.3209L9.64531 9.32727Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M12.0031 1.00084L11.9805 5.37995L15.9366 3.39705L15.9376 3.396L17.6486 5.107L17.6472 5.10772L14.5346 8.18806L18.7345 9.58271V12.0026L14.3499 11.9801L16.3326 15.9338L14.6215 17.6451L11.5492 14.5406L10.1507 18.7509L7.73194 18.7502L7.75451 14.3708L3.79795 16.354L3.79694 16.355L2.08634 14.6438L5.19936 11.563L1 10.1686V7.74823L5.38458 7.77084L3.4021 3.8169L5.11328 2.1059L8.1851 5.20988L9.58295 1.00031L12.0031 1.00084ZM12.0565 11.6591L11.7795 11.9361L10.1003 12.7039H9.75878L8.06653 12.0736L7.79594 11.802L7.047 10.1664V9.7766L7.67032 8.09973L7.95528 7.8149L9.63373 7.04731H9.97607L11.6682 7.67761L11.9392 7.94869L12.6875 9.58494L12.6878 9.97479L12.0646 11.6509L12.0565 11.6591Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M14.404 1.20038L14.4036 1.20162L14.3765 6.45601L19.1238 4.07651L19.1251 4.07526L21.1783 6.12846L21.1763 6.12946L17.4414 9.82568L22.4813 11.4993V14.4032L17.2199 14.3761L19.5992 19.1206L17.5459 21.1742L13.8591 17.4488L12.1809 22.5011L9.27833 22.5003L9.30542 17.245L4.55778 19.6246L4.55637 19.626L2.50371 17.5725L6.23926 13.8757L1.19995 12.2023V9.29785L6.46153 9.32498L4.08228 4.5803L6.13574 2.5271L9.82199 6.25195L11.4994 1.20038H14.404ZM14.4679 13.991L14.1355 14.3234L12.1204 15.2447H11.7105L9.67999 14.4884L9.35517 14.1624L8.45635 12.1995V11.7319L9.20427 9.71983L9.54614 9.3779L11.5598 8.45703H11.9719L14.0018 9.21314L14.3269 9.53854L15.2249 11.502L15.2251 11.9698L14.4772 13.9814L14.4679 13.991Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M19.2051 1.60162L19.2055 1.60046H15.3329L13.0963 8.33603L8.18115 3.36945L5.44336 6.10705L8.61545 12.4333L1.60034 12.3971L1.6001 16.2698L8.31907 18.5009L3.3382 23.4302L6.07525 26.168L6.07721 26.1661L12.4075 22.9932L12.3713 30.0007L16.2415 30.0014L18.4789 23.265L23.3946 28.2321L26.1324 25.4941L22.9599 19.1681L29.9753 19.2042V15.3322L23.2553 13.1008L28.235 8.17263L28.2379 8.17119L25.5003 5.43359L25.4984 5.43546L19.169 8.60796L19.2051 1.60162ZM18.8474 19.0977L19.2906 18.6545L19.3031 18.6418L20.3003 15.9596L20.3 15.3365L19.1026 12.718L18.6691 12.2841L15.9619 11.2757L15.9627 11.2734H15.9614L15.9607 11.2757H15.414L12.7284 12.5038L12.273 12.9592L11.2753 15.6426V16.2661L12.4736 18.8832L12.9065 19.3176L15.6143 20.3262H16.1605L18.8474 19.0977Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;